import type { HookFormValidate_Type } from "../../../../_ovlclient/src/global/hooks"
import { SYSAction } from "../../../src"

import { FieldId } from "./loginform"

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (value) => {
  let field = value.field

  switch (<FieldId>field.fieldKey) {
    case "pw":
      value.validatorUse("Mandatory")
      break
    case "user":
      if (value.validatorUse("Mandatory")) {
        value.validatorUse("MinLength", { val: 3 })
      }
      break
  }
}

export let hooks = { HookFormValidate }
